// 验证电话号码
function checkMobile(tel) {
  return /^1[3456789]\d{9}$/.test(tel);
}
export default checkMobile;